import { useGetTimetablesQuery } from '@schooly/api';
import { useMemo } from 'react';

import {
  buildGroupConflictMap,
  GroupConflict,
  selectOtherPublishedTimetables,
} from './groupConflicts';

type UsePublishedGroupConflictsParams = {
  schoolId: string;
  schoolYearId: string;
  currentStructureId: string;
};

type UsePublishedGroupConflictsResult = {
  conflictMap: Map<string, GroupConflict>;
  isLoading: boolean;
};

export const usePublishedGroupConflicts = ({
  schoolId,
  schoolYearId,
  currentStructureId,
}: UsePublishedGroupConflictsParams): UsePublishedGroupConflictsResult => {
  const { data, isFetching } = useGetTimetablesQuery(
    { school_id: schoolId, school_year_id: schoolYearId },
    {
      enabled: !!schoolId && !!schoolYearId,
      refetchOnMount: 'always',
    },
  );

  const conflictMap = useMemo(() => {
    const publishedTimetables = data
      ? selectOtherPublishedTimetables(data.timetables, currentStructureId, schoolYearId)
      : [];

    return buildGroupConflictMap(
      publishedTimetables.map((timetable) => ({
        id: timetable.id,
        name: timetable.name,
        groupIds: timetable.group_ids,
      })),
    );
  }, [currentStructureId, data, schoolYearId]);

  return { conflictMap, isLoading: isFetching };
};
